import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import { Button, Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import GenericSelection from '../../Common/GenericSelection';
import {
    ROOT_URL, ROOT_API_URL, isLAP, isOLG, isSV, isEKC, isLMH, isBRO, isSDR
} from '../../../actions/root_url';

const paymentOptions = [
    { value: 'CreditCard', label: 'Credit Card' },
    { value: 'DebitCard', label: 'Debit Card' },
    // { value: 'StoreCredit', label: 'Store Credit' },
    { value: 'Cash', label: 'Cash' },
    { value: 'Check', label: 'Check' },
    // { value: 'Zello', label: 'Zello' },
    // { value: 'Venmo', label: 'Venmo' },
    // { value: 'Other', label: 'Other' },
];

class RefundModal extends Component {
    constructor() {
        super();
        this.state = {
            payment_method: null,
            // amount: 0,
            sales_invoice_id: null,
            sales_return_id: null,
            // access_token: null,
            isCallingApi: false,
            checkNum: '',
        };
        // this.subjectRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            console.log("OPEN", this.props.selectedRows);
        }
    }

    handleConfirm = () => {
        const { selectedRows } = this.props;

        localStorage.setItem('cloverRoute', 'SR');
        if (!localStorage.getItem('cloverToken') && false) {
            alert("Please log in to Clover before charging first. Navigating to log in page..")
            window.location.href = "https://sandbox.dev.clover.com/oauth/authorize?client_id=2S3D1ZVPS1F9W";
        }

        let url = `${ROOT_URL}v1/hante/sales_return_hante_refund`;
        let data = {
            payment_method: this.state.payment_method ? this.state.payment_method.value : null,
            amount: (this.props.selectedRows && this.props.selectedRows.length > 0) ? (Number(this.props.selectedRows[0].FinalPrice) * 100).toFixed(0) : 0,
            sales_invoice_id: (this.props.selectedRows && this.props.selectedRows.length > 0) ? this.props.selectedRows[0].SalesInvoice_id_id : null,
            sales_return_id: (this.props.selectedRows && this.props.selectedRows.length > 0) ? this.props.selectedRows[0].SalesReturn_id : null,
            // access_token: localStorage.getItem('cloverToken'),
            check_num: (this.state.payment_method && this.state.payment_method.value === 'Check') ? this.state.checkNum : '',
        }
        this.setState({ isCallingApi: true });
        if (this.state.payment_method && (this.state.payment_method.value === 'CreditCard' || this.state.payment_method.value === 'DebitCard')) {
            this.setState({ displayMessage: "Please complete transaction on POS machine..." });
        } else {
            this.setState({ displayMessage: "Processing..." });
        }
        axios({
            method: 'POST',
            url: url,
            data: data,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                this.setState({ isCallingApi: false });
                // if (res.data === "Unauthorized"
                //     || res.data === 'Missing bearer token or Authorization header not set.') {
                //     alert("Clover login has expired, please log into Clover again before charging. Navigating to Clover..");
                //     window.location.href = "https://sandbox.dev.clover.com/oauth/authorize?client_id=2S3D1ZVPS1F9W";
                // } else 
                if (res.data === 'True') {
                    alert("Refund Success");
                    // this.props.fetchDataWithFilters();
                    this.props.onFinish();
                    this.props.onClose();
                } else if (res.data) {
                    alert(JSON.stringify(res.data));
                }
            }, err => {
                this.setState({ isCallingApi: false });
                alert(JSON.stringify(err.data));
            })

    }

    handleDropdownChange = (target) => {
        this.setState({
            payment_method: target,
        })
    }

    handleInputChange = ({ target }) => {
        this.setState({
            [target.name]: target.value,
        })
    }

    render() {
        const { visible, onClose } = this.props;
        return <SkyLightStateless
            dialogStyles={styles.modal}
            isVisible={visible}
            onCloseClicked={this.state.isCallingApi ? null : onClose}
            title={'Refund'}
        >
            <div style={styles.container}>

                <Row>
                    <Col sm={12} alignContent="center">
                        <p style={{ fontSize: '15px', marginBottom: '0px', fontWeight: 'bold' }}>Customer: {(this.props.selectedRows && this.props.selectedRows.length > 0) ? this.props.selectedRows[0].Deliver_Customer_Name : ''}</p>
                        <p style={{ fontSize: '15px', marginBottom: '20px', fontWeight: 'bold' }}>Refund Amount: ${(this.props.selectedRows && this.props.selectedRows.length > 0) ? this.props.selectedRows[0].FinalPrice : 0}</p>
                    </Col>
                </Row>
                <Row>
                    {/* <Col sm={4} alignContent="center">
                        <label ><Translate value="payment_type" /></label>
                    </Col> */}
                    <Col sm={12}>
                        <label style={{}}><Translate value="payment_type" />:</label>
                        <div className="email365">
                            <GenericSelection
                                options={paymentOptions}
                                value={this.state.payment_method}
                                setSelected={(e) => { this.handleDropdownChange(e) }}
                            />
                        </div>
                    </Col>
                </Row>

                {
                    (this.state.payment_method && this.state.payment_method.value === 'Check') &&
                    <Row>
                        {/* <Col sm={4} alignContent="center">
                        <label ><Translate value="payment_type" /></label>
                    </Col> */}
                        <Col sm={12}>
                            <label style={{}}><Translate value="check_num" />:</label>
                            <div className="email365">
                                <input
                                    name='checkNum'
                                    className='form-control'
                                    style={{width: '250px'}}
                                    value={this.state.checkNum}
                                    onChange={e => this.handleInputChange(e)}
                                    autoFocus
                                // ref={subjectRef}
                                />
                            </div>
                        </Col>
                    </Row>
                }

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '10px'
                }}>
                    <Button
                        classNames="btn-primary"
                        disabled={!this.state.payment_method || this.state.isCallingApi}
                        onClick={this.handleConfirm}
                    >
                        {/* <i className="fa fa-envelope" /> */}
                        <Translate value="confirm" />
                    </Button>
                </div>

                {
                    this.state.isCallingApi &&
                    <Row>
                        <Col sm={12} alignContent="center">
                            <p style={{ fontSize: '14px', marginTop: '20px' }}>
                                {this.state.displayMessage}
                            </p>
                        </Col>
                    </Row>
                }
            </div>
        </SkyLightStateless>
    }

}


const styles = {
    modal: {
        width: '575px',
        height: '400px',
        marginLeft: '-9%',
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    sectionPadding: {
        marginBottom: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    row: {
        display: 'flex', flexDirection: 'row', marginBottom: '10px', alignItems: 'center'
    }
};

export default RefundModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/RefundModal.jsx